<template>

	<div>

        <Ubicacion @status="statusUbicacion" :servicio="servicio" :cliente="cliente"></Ubicacion>
        <TipoBusqueda :url="url" v-if="ubicacion" :servicio="servicio"></TipoBusqueda>
        <ModalParqueadero @datosDireccion="confirmarDatosDireccion" :datosDireccion="servicio.datosDireccion" v-if="this.formParqueadero && !ubicacion && !this.servicio.datosDireccion.parqueadero"></ModalParqueadero>

	</div>

</template>

<script>
    import Ubicacion from './Ubicacion'
    import TipoBusqueda from './TipoBusqueda'
    import ModalParqueadero from './ModalParqueadero'

    export default {
        components: {Ubicacion, TipoBusqueda, ModalParqueadero},
        props: [
            'url',
            'servicio',
            'cliente'
        ],
        data() {
            return {
                ubicacion: false,
                formParqueadero: false
            }
        },
        watch: {

        },
        methods: {
            statusUbicacion(params){
                // console.log('--- obteniendo estado de compomente ubicación ---')
                // console.log(params)
                this.ubicacion = false
                this.formParqueadero = false
                if(params.status){
                    this.servicio.ciudad = params.ciudad
                    this.servicio.datosDireccion.direccion = params.direccion
                    if(!params.parqueadero || !params.ascensor){
                        this.formParqueadero = true
                    }else{
                        this.ubicacion = true
                        this.servicio.datosDireccion.parqueadero = params.parqueadero
                        this.servicio.datosDireccion.ascensor = params.ascensor
                        // this.servicio.datosDireccion.valorparqueadero = params.valorParqueadero
                        // this.servicio.datosDireccion.valorascensor = params.valorAscensor
                    }
                }else{
                    this.ubicacion = false
                }
            },
            confirmarDatosDireccion(params){
                // console.log('--- obteniendo econfirmación datos de direccion ---')
                this.servicio.datosDireccion.ascensor = params.ascensor
                this.servicio.datosDireccion.parqueadero = params.parqueadero
                this.servicio.datosDireccion.valorParqueadero = params.valorParqueadero
                this.servicio.datosDireccion.valorAscensor = params.valorAscensor
                this.ubicacion = true
            }
        },
        mounted() {
            // console.log('--- service component mounted ---')
        }
    }
</script>